import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, Copy } from 'lucide-react';
import { useData } from '@/context/DataContext';
import ProposalRenderer from '@/components/proposal/ProposalRenderer';
import { normalizeQuote } from '@/lib/normalizeQuote';


export default function QuoteView() {
  const { id } = useParams();
  const { quotes } = useData();
  const navigate = useNavigate();

  const raw = quotes.find((q) => q.id === id);
  const quote = raw ? normalizeQuote(raw) : null;  

  if (!quote) {
    return (
      <div className="flex-1 flex items-center justify-center bg-neutral-950">
        <div className="text-center">
          <div className="text-neutral-400 mb-4">Cotización no encontrada</div>
          <button
            onClick={() => navigate('/')}
            className="text-brand-gold hover:underline text-sm"
          >
            ← Volver al dashboard
          </button>
        </div>
      </div>
    );
  }

  const publicUrl = quote.publicToken
    ? `${import.meta.env.VITE_PUBLIC_BASE_URL || window.location.origin}/p/${quote.publicToken}`
    : null;

  const copyPublicLink = () => {
    if (publicUrl) {
      navigator.clipboard.writeText(publicUrl);
      alert('Link público copiado');
    }
  };

  return (
    <div className="flex-1 overflow-auto">
      <div className="sticky top-0 z-20 bg-black border-b border-neutral-900 px-6 py-3 flex items-center justify-between no-print">
        <button
          onClick={() => navigate('/')}
          className="text-sm text-neutral-400 hover:text-white flex items-center gap-2"
        >
          <ChevronLeft className="w-4 h-4" /> Volver
        </button>
        <div className="text-xs text-neutral-500">
          Vista previa · Así verá la propuesta el cliente
        </div>
        <div className="flex items-center gap-3">
          {publicUrl && (
            <button
              onClick={copyPublicLink}
              className="text-xs text-neutral-400 hover:text-white flex items-center gap-1.5 px-3 py-1.5 border border-neutral-800 rounded"
            >
              <Copy className="w-3 h-3" /> Copiar link público
            </button>
          )}
          <div className="text-xs text-neutral-500">
            Folio: <span className="text-white font-mono">{quote.folio}</span>
          </div>
        </div>
      </div>

      <ProposalRenderer quote={quote} allowAccept={false} />
    </div>
  );
}
